import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Alert, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { listAddresses } from '../../../actions/addressActions'
import { addressListReset } from '../../../reducers/addressReducers'
import Address from '../Address/Address'
import CreateAddressModal from '../Address/CreateAddressModal'
import Loader from '../../Loader'
import Message from '../../Message'
import { FaExclamationTriangle, FaPlus } from 'react-icons/fa'
import '../styles.css'
import { useNavigate } from 'react-router-dom'
import { logout } from '../../../actions/userActions'
import { COLORS } from '../../../constants/colors'

function AddressScreen() {
    const [showCreateModal, setShowCreateModal] = useState(false)
    
    // Updated selector to match the correct path in Redux store
    const { loading, error, addresses } = useSelector((state) => state.addressReducers)
    
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const loadAddresses = () => {
        dispatch(listAddresses())
    }

    useEffect(() => {
        loadAddresses()
        return () => {
            dispatch(addressListReset())
        }
    }, [dispatch])

    // Handle authentication error
    useEffect(() => {
        if (error && error.includes('Authentication credentials were not provided')) {
            dispatch(logout())
            navigate('/')
        }
    }, [error, dispatch, navigate])

    const createModalShow = () => setShowCreateModal(true)
    const createModalClose = () => setShowCreateModal(false)

    // Color palette for alerts and messages using the new color scheme
    const plum = COLORS.PLUM;
    const sageGreen = COLORS.SAGE_GREEN;
    const warmConcrete = COLORS.WARM_CONCRETE;

    // Check if addresses array is valid
    const hasValidAddresses = Array.isArray(addresses) && addresses.length > 0

    // Log data for debugging
    console.log('Address data from Redux:', { addresses, loading, error, hasValidAddresses })

    return (
        <>
            {loading ? (
                <Loader />
            ) : error && !error.includes('Authentication credentials were not provided') ? (
                <Message variant='danger'>{error}</Message>
            ) : (
                <>
                    <Row className='mx-3 mb-4'>
                        <Col className='h5' style={{cursor: 'pointer'}} onClick={createModalShow}>
                            <FaPlus size={16} className="me-2" /> <span className='h5' style={{ color: plum }}>Add Address Details</span>
                        </Col>
                    </Row>
                    <Row className='mx-3'>
                        <Col className='d-flex justify-content-center mb-4'>
                            <hr className='divider'/>
                        </Col>
                    </Row>

                    <Row>
                        {hasValidAddresses ? (
                            addresses.map((address) => (
                                address && address._id ? (
                                    <Col key={address._id} sm="12" md="6" lg="6" xl="6" className='mb-3'>
                                        <Address address={address} />
                                    </Col>
                                ) : (
                                    <Col key={`invalid-${Math.random()}`} sm="12" className='mb-3'>
                                        <Alert 
                                            className="text-center p-2" 
                                            style={{ 
                                                backgroundColor: warmConcrete, 
                                                color: plum,
                                                borderRadius: 4, 
                                                border: `1px solid ${plum}`
                                            }}
                                        >
                                            <div className="d-flex align-items-center justify-content-center">
                                                <FaExclamationTriangle size={14} className="me-2" />
                                                <strong>Invalid address data detected. Please try again.</strong>
                                            </div>
                                        </Alert>
                                    </Col>
                                )
                            ))
                        ) : (
                            <Col className="mt-4">
                                <Alert 
                                    className="text-center p-2" 
                                    style={{ 
                                        backgroundColor: warmConcrete, 
                                        color: plum,
                                        borderRadius: 4, 
                                        border: `1px solid ${plum}`
                                    }}
                                >
                                    <div className="d-flex align-items-center justify-content-center">
                                        <FaExclamationTriangle size={14} className="me-2" />
                                        <strong>No addresses found. Add your first address to get started.</strong>
                                    </div>
                                </Alert>
                            </Col>
                        )}
                    </Row>
                </>
            )}

            <CreateAddressModal 
                show={showCreateModal}
                onHide={createModalClose}
                dispatch={dispatch}
            />
        </>
    )
}

export default AddressScreen